import React from 'react';
import PropTypes from 'prop-types';

import { btnLocationEnum } from 'utils/segment';
import { getVariantData } from 'utils/subscriptions';

import withSelectedVariant from 'HOC/withSelectedVariant/withSelectedVariant';
import ProductDetailPageCTA from '../ProductDetailPageCTA/ProductDetailPageCTA';

import styles from './FloatingCTA.module.scss';

export const FloatingCTA = ({
  // eslint-disable-next-line no-unused-vars
  variants, // we need variants for withSelectedVariant HOC
  campaignProductData,
  isParisHiltonKit,
  productName,
  selectedVariant,
  variantIdsBeingUpdated,
  addToPublicCart,
}) => {
  const { id, isSubscriptionAvailable } = selectedVariant;
  const { salePrice, soldOut, sku } = getVariantData(
    selectedVariant,
    campaignProductData,
    isSubscriptionAvailable
  );
  const isPublicShop =
    campaignProductData?.subscribable || isSubscriptionAvailable;
  const isUpdatingCart = variantIdsBeingUpdated.has(id);

  if (!isPublicShop) return null;

  return (
    <div className={styles.container}>
      <ProductDetailPageCTA
        id={id}
        sku={sku}
        soldOut={soldOut}
        salePrice={salePrice}
        productName={productName}
        isSubscriptionAvailable={isSubscriptionAvailable}
        isParisHiltonKit={isParisHiltonKit}
        isUpdatingCart={isUpdatingCart}
        acquisitionType={btnLocationEnum.floatingCTA}
        addToPublicCart={addToPublicCart}
      />
    </div>
  );
};

FloatingCTA.propTypes = {
  variants: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  campaignProductData: PropTypes.shape({
    subscribable: PropTypes.bool,
  }).isRequired,
  isParisHiltonKit: PropTypes.bool.isRequired,
  productName: PropTypes.string.isRequired,
  selectedVariant: PropTypes.shape({}).isRequired,
  variantIdsBeingUpdated: PropTypes.shape({}).isRequired,
  addToPublicCart: PropTypes.func.isRequired,
};

export default withSelectedVariant(false)(FloatingCTA);
